// extracted by mini-css-extract-plugin
export default {"dialog":"HomeDialog_dialog__pQXCL","wide":"HomeDialog_wide__SqVtP","header":"HomeDialog_header__g0-+Z"};